import { email, helpers, numeric, required } from '@vuelidate/validators';
import ApplicationsBusinessOperator from './ApplicationsBusinessOperator';
import ApplicationsBusinessPrincipal from './ApplicationsBusinessPrincipal';
import ApplicationsResidence from './ApplicationsResidence';
import CustomerResidence from '../Customer/CustomerResidence';
import { EntityType } from '@core/classes/SharedEnums';
import LOCALIZATION from '../Localization';
import moment from 'moment';
import { validBusinessStartDate } from '@core/services/custom-validators';

export default class ApplicationsBusinessInfo {
	constructor(init) {
		this.legalName = null;
		this.businessStartDate = null;
		this.phoneNumber = null;
		this.emailAddress = null;
		this.businessOperator = new ApplicationsBusinessOperator();
		this.businessPrincipal = new ApplicationsBusinessPrincipal();
		/** Short description of business (ex: fast food restaurant, retail) */
		this.businessType = null;
		this.yearsInBusiness = null;
		this.taxIdHashed = null;
		this.taxIdLast4 = null;
		this.address = new CustomerResidence();

		this.hasGuarantor = null; // Customer App Specific
		this.isApplicantGuarantor = null; // Customer APP specific
		this.enterpriseType = null; // Replaced with Entity Type
		this.guarantorEstimateCreditScore = null; // Customer App Specific
		this.tradeName = null; // Replaced with DBA
		this.grossMontlyProfit = null; // Changed Data type, fixed typo

		/** ---- New properties --- */

		/** new enterprise type. Typescript: entityType: EntityType = EntityType.Unknown;*/
		this.entityType = null;
		/** List of strings. "Doing Business As." Any 'Aliases' for their Business Name. Typescript: dbas?: string[] = [] */
		this.dbas = [];
		/** Obsolete */
		//TODO: Remove on second release
		this.addresses = init?.addresses?.map(address => new ApplicationsResidence(address)) || [];
		/** New property for gross monthly profit of the business. Typescript: grossMonthlyProfit?: number = null */
		this.grossMonthlyProfit = null;

		if (init) {
			this.hasGuarantor = init.hasGuarantor;
			this.isApplicantGuarantor = init.isApplicantGuarantor;
			this.guarantorEstimateCreditScore = init.guarantorEstimateCreditScore;
			this.legalName = init.legalName;
			this.tradeName = init.tradeName;
			this.enterpriseType = init.enterpriseType;
			this.taxIdLast4 = init.taxIdLast4;
			this.taxIdHashed = init.taxIdHashed;
			this.businessStartDate = init.businessStartDate
				? moment(init.businessStartDate, 'YYYY-MM-DDTHH:mm:ss.SSSSSSS[Z]').format('YYYY-MM-DDTHH:mm:ss.SSSSSSS[Z]')
				: init.businessStartDate;
			this.phoneNumber = init.phoneNumber;
			this.emailAddress = init.emailAddress;
			this.address = new CustomerResidence(init.address);
			this.businessOperator = new ApplicationsBusinessOperator(init.businessOperator);
			this.grossMontlyProfit = init.grossMontlyProfit;
			this.businessPrincipal = new ApplicationsBusinessPrincipal(init.businessPrincipal);
			this.businessType = init.businessType;

			//calculations
			this.yearsInBusiness = init.yearsInBusiness;

			//New Properties
			this.entityType = init.entityType;
			this.dbas = init.dbas;
			this.grossMonthlyProfit = init.grossMonthlyProfit;
			//TODO: Remove on second release
			if (init?.addresses) {
				this.addresses = init.addresses.map(address => new ApplicationsResidence(address));
			}
		}
	}

	validation(includeResidenceStatus = false, language = 'English') {
		const requiredWithMessage = key => helpers.withMessage(LOCALIZATION.customerPortalAddBusinessForm[key][language], required);

		return {
			legalName: { required: requiredWithMessage('legalNameRequired') },
			businessStartDate: {
				required: requiredWithMessage('businessStartDateRequired'),
				validDate: helpers.withMessage(LOCALIZATION.customerPortalAddBusinessForm.businessStartDateInvalid[language], validBusinessStartDate),
			},
			phoneNumber: {
				numeric: helpers.withMessage(LOCALIZATION.customerPortalAddBusinessForm.invalidPhoneNumberFormat[language], numeric),
				required: requiredWithMessage('phoneNumberRequired'),
				validPhone: helpers.withMessage(LOCALIZATION.customerPortalAddBusinessForm.invalidPhoneNumberFormat[language], value => value.length === 10),
			},
			emailAddress: {
				required: requiredWithMessage('emailRequired'),
				email: helpers.withMessage(LOCALIZATION.customerPortalAddBusinessForm.emailInvalid[language], email),
			},
			entityType: { required: requiredWithMessage('entityTypeRequired') },
			grossMonthlyProfit: {
				required: requiredWithMessage('grossMonthlyProfitRequired'),
			},
			// address: this.addresses.map(a => a.validation(includeResidenceStatus, language)),
			businessOperator: this.businessOperator.validation(language),
			businessPrincipal: this.businessPrincipal.validation(language),
		};
	}
}
